export {Label, Label as default} from './label';
export {LabelBase} from './label-base';
export {Tags} from './label';

export type {LabelProps, TagName} from './label';
export type {LabelBaseProps, NativeLabelProps} from './label-base';
